import { signal } from 'services/SignalsService'
import { tweenSequence } from 'settings/tweenSequence'
import { moveIn } from 'utils/Tweens'

export default class FreespinsEndEntity extends PIXI.Container {
  constructor() {
    super()

    signal.on('STATE:IN:FS-END', () => {
      const endButton = this.getChildByName('endFreespin')
      if(endButton && endButton._data.tween){
        moveIn(endButton, {
          startX: endButton.x,
          startY: 1400,
          endX: endButton.x,
          endY: endButton.y,
          ...tweenSequence.startFreeSpinButtonAppears,
        })
      }
    })
  }
}
